export enum SearchMode { 
    customerAccountNumber, 
    customerNameContains, 
    surnameBegins,
    companyNameBegins,
    postalCodeBegins,
    telephoneNumberBegins,
    emailAddressBegins,
  legacyAccountNumber,
  includeActiveAccountsOnly
};
export interface ISearchCustomers {
    customerAccountNumber?: string;
    customerAccountNumberPrefix?: string;
    customerNameContains?: string;
    surnameBegins?: string;
    companyNameBegins?: string;
    postalCodeBegins?: string;
    telephoneNumberBegins?: string;
    emailAddressBegins?: string;
    legacyAccountNumber?: string;
    includeActiveAccountsOnly?: boolean;
    mode?: SearchMode
}
